import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { ReferenceRate } from 'src/features/referenceRates/utils/types';
import { ReferenceRateFormSchemaValues } from 'src/features/referenceRates/utils/formSchema';

const RESOURCE = '/subscriptions/reference-rate/';

type MutationFnType = typeof mutationFn;

const mutationFn = (data: ReferenceRateFormSchemaValues): Promise<ReferenceRate> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateReferenceRate };
